import { render, staticRenderFns } from "./SanityLanderFooter.vue?vue&type=template&id=7384bd8a&scoped=true"
import script from "./SanityLanderFooter.vue?vue&type=script&lang=js"
export * from "./SanityLanderFooter.vue?vue&type=script&lang=js"
import style0 from "./SanityLanderFooter.vue?vue&type=style&index=0&id=7384bd8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7384bd8a",
  null
  
)

export default component.exports